(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["everden-product-landing"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('everden-product-landing')) {
    customElements.define('everden-product-landing', class EverdenProductLanding extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
        this.form = this.querySelector('.epl__form');
        this.variantInput = this.querySelector('[data-variant-id]');
        this.price = this.querySelector('[data-price]');
        this.atc = this.querySelector('[data-atc]');
        this.atcText = this.querySelector('[data-atc-text]');
        this.atcPrice = this.querySelector('[data-atc-price]');
        this.sticky = this.querySelector('[data-sticky]');
        this.stickyPrice = this.querySelector('[data-sticky-price]');
        this.powerNote = this.querySelector('[data-power-note]');

        this.querySelectorAll('[data-gallery-thumb]').forEach((button) => {
          button.addEventListener('click', () => this.showSlide(button.dataset.galleryThumb));
        });

        this.querySelectorAll('input[name^="fruit-"], input[name^="power-"]').forEach((input) => {
          input.addEventListener('change', () => this.updateVariant());
        });

        const bundleLink = this.querySelector('[data-scroll-bundle]');
        if (bundleLink) {
          bundleLink.addEventListener('click', () => this.querySelector('.epl__bundle').scrollIntoView({ behavior: 'smooth', block: 'start' }));
        }

        const scrollBuy = this.querySelector('[data-scroll-buy]');
        if (scrollBuy) {
          scrollBuy.addEventListener('click', () => this.querySelector('.epl__buy-card').scrollIntoView({ behavior: 'smooth', block: 'start' }));
        }

        const stickyAtc = this.querySelector('[data-sticky-atc]');
        if (stickyAtc && this.form) stickyAtc.addEventListener('click', () => this.form.requestSubmit());

        this.setupBundle();
        this.setupSticky();
        this.updateVariant();
      }

      selectedValue(prefix) {
        const input = this.querySelector('input[name^="' + prefix + '"]:checked');
        return input ? input.value : '';
      }

      findVariant(fruit, power) {
        return this.variants.find((variant) => {
          const title = variant.title.toLowerCase();
          return title.includes(fruit) && title.includes(power);
        });
      }

      updateVariant() {
        const fruit = this.selectedValue('fruit-');
        const power = this.selectedValue('power-');
        const variant = this.findVariant(fruit, power);
        if (!variant) return;

        if (this.powerNote) {
          this.powerNote.textContent = power === 'rechargeable'
            ? this.powerNote.dataset.rechargeableNote
            : this.powerNote.dataset.batteryNote;
        }

        this.variantInput.value = variant.id;
        this.price.textContent = variant.price;
        this.atcPrice.textContent = variant.price;
        if (this.stickyPrice) this.stickyPrice.textContent = variant.price;

        this.atc.disabled = !variant.available;
        this.atcText.textContent = variant.available ? this.dataset.addText : this.dataset.soldOutText;
      }

      showSlide(index) {
        this.querySelectorAll('[data-slide]').forEach((slide) => {
          const active = slide.dataset.slide === String(index);
          slide.hidden = !active;
          slide.classList.toggle('is-active', active);
        });
        this.querySelectorAll('[data-gallery-thumb]').forEach((button) => {
          const active = button.dataset.galleryThumb === String(index);
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      }

      setupBundle() {
        this.bundleSubmit = this.querySelector('[data-bundle-submit]');
        if (!this.bundleSubmit) return;

        this.bundlePicks = this.querySelector('[data-bundle-picks]');
        this.bundleAll = this.querySelector('[data-bundle-all]');
        this.bundleError = this.querySelector('[data-bundle-error]');
        this.bundleFirst = this.querySelector('[data-bundle-first]');
        this.bundleSecond = this.querySelector('[data-bundle-second]');

        this.querySelectorAll('input[name^="bundle-size-"]').forEach((input) => {
          input.addEventListener('change', () => this.updateBundle());
        });
        this.bundleSubmit.addEventListener('click', () => this.addBundle());
        this.updateBundle();
      }

      updateBundle() {
        const size = Number(this.selectedValue('bundle-size-'));
        const isTwo = size === 2;
        this.bundlePicks.hidden = !isTwo;
        this.bundleAll.hidden = isTwo;
        this.bundleSubmit.textContent = isTwo ? this.dataset.bundleAddTwo : this.dataset.bundleAddThree;
        this.bundleError.textContent = '';
      }

      async addBundle() {
        const size = Number(this.selectedValue('bundle-size-'));
        const power = this.selectedValue('bundle-power-');
        const fruits = size === 2
          ? [this.bundleFirst.value, this.bundleSecond.value]
          : ['banana', 'carrot', 'strawberry'];

        const selected = fruits.map((fruit) => this.findVariant(fruit, power));
        if (selected.some((variant) => !variant || !variant.available)) {
          this.bundleError.textContent = this.dataset.bundleUnavailable;
          return;
        }

        const grouped = new Map();
        selected.forEach((variant) => grouped.set(variant.id, (grouped.get(variant.id) || 0) + 1));
        const bundleName = size === 2 ? 'Everden 2-Pack' : 'Everden 3-Pack';

        this.bundleError.textContent = '';
        this.bundleSubmit.disabled = true;
        this.bundleSubmit.textContent = this.dataset.bundleAdding;

        const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';

        try {
          const response = await fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              items: Array.from(grouped.entries()).map(([id, quantity]) => ({
                id: Number(id),
                quantity: quantity,
                properties: { _Bundle: bundleName }
              }))
            })
          });

          if (!response.ok) throw new Error('Cart request failed');

          const code = size === 2 ? this.dataset.twoCode : this.dataset.threeCode;
          window.location.assign(root + 'discount/' + encodeURIComponent(code) + '?redirect=/cart');
        } catch (error) {
          this.bundleError.textContent = this.dataset.bundleError;
          this.bundleSubmit.disabled = false;
          this.updateBundle();
        }
      }

      setupSticky() {
        if (!this.sticky || !this.form || !('IntersectionObserver' in window)) return;
        const observer = new IntersectionObserver((entries) => {
          const entry = entries[0];
          this.sticky.hidden = entry.isIntersecting;
        }, { threshold: 0.12 });
        observer.observe(this.form);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
